import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Plus } from 'lucide-react';

interface Props {
  onOpenMenu: () => void;
}

/**
 * Slim top bar for the in-app shell - visible on mobile only (where the
 * sidebar is hidden behind a hamburger). On desktop the sidebar carries the
 * branding and primary CTA so we hide this bar entirely.
 */
const AppHeaderBar: React.FC<Props> = ({ onOpenMenu }) => {
  return (
    <div className="lg:hidden sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-light-gray">
      <div className="flex items-center justify-between px-4 sm:px-6 py-3">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onOpenMenu}
            className="p-2 -ml-2 rounded-lg text-charcoal hover:bg-light-gray transition-colors"
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
          <Link to="/app" className="flex items-center gap-2">
            <img src="/logo.png" alt="Suitcase Muse" className="w-8 h-8 rounded-lg" />
            <span className="font-nunito font-bold text-base text-charcoal">Suitcase Muse</span>
          </Link>
        </div>

        <Link
          to="/app/trips/new"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-coral text-white text-sm font-semibold hover:bg-coral/90 transition-colors"
        >
          <Plus size={16} />
          New Plan
        </Link>
      </div>
    </div>
  );
};

export default AppHeaderBar;
